import IntlMessageFormat from 'intl-messageformat';

const moduleCache = new WeakMap();
const getParsedICUMessages = (m, locale) => {
  const moduleCachedResult = moduleCache.get(m);
  if (moduleCachedResult && moduleCachedResult[locale]) {
    return moduleCachedResult[locale];
  }
  const parsedICUMessages = {};
  for (const translation of Object.keys(m)) {
    const intlMessageFormat = new IntlMessageFormat(m[translation], locale);
    parsedICUMessages[translation] = {
      format: params => intlMessageFormat.format(params)
    };
  }
  moduleCache.set(m, {
    ...moduleCachedResult,
    [locale]: parsedICUMessages
  });
  return parsedICUMessages;
};

export { getParsedICUMessages };
